export const getSecret = () => {
    const data = '1234567890aAbBcCdDeEfFgGhHiIjJkKlLmMnNoOpPqQrRsStTuUvVwWxXyYzZ';
    const idx1 = Math.floor(Math.random() * data.length);
    const idx2 = Math.floor(Math.random() * data.length);
    const idx3 = Math.floor(Math.random() * data.length);
    const idx4 = Math.floor(Math.random() * data.length);
    return `${data[idx1]}${data[idx2]}${data[idx3]}${data[idx4]}`;
};
